import { render, staticRenderFns } from "./CoursesSection.vue?vue&type=template&id=70e08a02&scoped=true"
import script from "./CoursesSection.vue?vue&type=script&lang=js"
export * from "./CoursesSection.vue?vue&type=script&lang=js"
import style0 from "./CoursesSection.vue?vue&type=style&index=0&id=70e08a02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e08a02",
  null
  
)

export default component.exports